import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import {
  LOCATION_DATA,
  PROPERTIES_CHICAGO_PROPERTY_SWITCH_ENABLED,
  PROPERTIES_NOT_RELEASED
} from 'utils/constants';
import { QUERY_GET_REMOTE_CONFIG_ENTRY } from 'utils/hook/query/useRemoteConfigEntry';

const withEnabledLocations = BaseComponent => {
  const EnabledLocations = props => {
    const { subscribeToNewData, disabledLocationsData, ...otherProps } = props;

    useEffect(() => {
      const unsubscribe = subscribeToNewData();
      return () => unsubscribe && unsubscribe();
    }, [subscribeToNewData]);

    let enabledLocations = Object.values(LOCATION_DATA);

    if (
      disabledLocationsData.remoteConfigEntry &&
      !disabledLocationsData.error
    ) {
      const locationsToDisable =
        disabledLocationsData.remoteConfigEntry.value.split(',');

      if (locationsToDisable.length) {
        enabledLocations = enabledLocations.filter(
          location =>
            !locationsToDisable.some(
              disabledLocation =>
                disabledLocation.toLowerCase().trim() ===
                location.id.toLowerCase()
            )
        );
      }
    } else {
      enabledLocations = enabledLocations.filter(
        location => location.assumeEnabled
      );
    }

    return (
      <BaseComponent enabledLocations={enabledLocations} {...otherProps} />
    );
  };

  const REMOTE_CONFIG_EVENT = gql`
    subscription remoteConfigEvent {
      remoteConfigEvent {
        action
        entries {
          key
          value
        }
      }
    }
  `;

  const withDisabledLocations = compose(
    graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
      name: 'disabledLocationsData',
      options: {
        variables: {
          key: PROPERTIES_NOT_RELEASED
        },
        fetchPolicy: 'cache-and-network'
      },
      props: ({ ownProps, disabledLocationsData }) => {
        return {
          disabledLocationsData,
          subscribeToNewData: () => {
            return disabledLocationsData.subscribeToMore({
              document: REMOTE_CONFIG_EVENT,
              updateQuery: (prev, { subscriptionData }) => {
                if (subscriptionData?.data?.action === 'Update') {
                  subscriptionData.data.entries.forEach(({ key, value }) => {
                    if (key === PROPERTIES_NOT_RELEASED) {
                      prev.remoteConfigEntry.value = value;
                    }
                  });
                }
                return prev;
              }
            });
          }
        };
      }
    }),
    graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
      name: 'chicagoPropertySwitchEnabled',
      options: {
        variables: {
          key: PROPERTIES_CHICAGO_PROPERTY_SWITCH_ENABLED
        },
        fetchPolicy: 'cache-and-network'
      },
      props: ({ ownProps, chicagoPropertySwitchEnabled }) => {
        return {
          chicagoPropertySwitchEnabled,
          subscribeToNewData: () => {
            return chicagoPropertySwitchEnabled.subscribeToMore({
              document: REMOTE_CONFIG_EVENT,
              updateQuery: (prev, { subscriptionData }) => {
                if (subscriptionData?.data?.action === 'Update') {
                  subscriptionData.data.entries.forEach(({ key, value }) => {
                    if (key === PROPERTIES_CHICAGO_PROPERTY_SWITCH_ENABLED) {
                      prev.remoteConfigEntry.value = value;
                    }
                  });
                }
                return prev;
              }
            });
          }
        };
      }
    })
  );

  return withDisabledLocations(EnabledLocations);
};

export default withEnabledLocations;
